import React, { memo } from 'react'
import { withStyles } from '@material-ui/core/styles'

import style from './style'
import { columnTitles } from '../../../options'

function ColumnHeader({ count, classes, stage }) {
  return (
    <div className={classes.header}>
      <div className={classes.top}>
        <div className={classes.titleWrap}>
          <div className={classes.title}>{columnTitles[stage]}</div>
        </div>

        <div className={classes.count}>{count}</div>
      </div>
    </div>
  )
}

export default memo(withStyles(style)(ColumnHeader))
